import { render } from "./SelectDistrict.vue?vue&type=template&id=50b23012"
import script from "./SelectDistrict.vue?vue&type=script&lang=js"
export * from "./SelectDistrict.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__